import { render, staticRenderFns } from "./academic-v2.vue?vue&type=template&id=4e34436a&"
import script from "./academic-v2.vue?vue&type=script&lang=js&"
export * from "./academic-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports